// Port of api/fuel/app/classes/controller/api/monty/presets/create.php
import DB from 'offline/db'
import Constants from 'offline/constants'

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var data = params.data || {}
	var name = String(data.name || '').trim()

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!name) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	DB.run('INSERT INTO preset (user_id, preset_type, preset_name, preset_filter, preset_default) VALUES (?, ?, ?, ?, ?)', [
		userId,
		parseInt(data.type, 10) || 0,
		name,
		JSON.stringify(data.filter || {}),
		0
	])

	var id = DB.scalar('SELECT last_insert_rowid()')

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {
				id: parseInt(id, 10) || 0
			}
		}
	})
}
